/**
 * UnlockContentSheet
 *
 * Helper to open the unlock content bottom sheet via SheetService.
 * Matches the pattern of ContentActionsSheet.tsx.
 *
 * Usage:
 *   UnlockContentSheet.show(media, container, screenKey);
 *
 * Flutter: lib/services/navigation_service.dart -> showUnlockContentSheet()
 */
import { SheetService } from '@/presentation/components/common/sheet/service/SheetService.index';
import { UnlockContentSheetContent } from './UnlockContentSheetContent';
import type { UserMediaEntity } from '@/domain/entities/userMedia/userMediaEntity';

const show = (
  media: UserMediaEntity,
  container?: HTMLElement | string | null,
  screenKey?: string,
) => {
  SheetService.show({
    title: '',
    content: (
      <UnlockContentSheetContent
        media={media}
        screenKey={screenKey}
        onClose={() => SheetService.close()}
      />
    ),
    container,
    screenKey,
    closeOnClickOutside: true,
  });
};

export const UnlockContentSheet = {
  show,
};
